import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import SydInput from '../../../../commonDesign/SydInput'

function serialize (arr) {
  return Array.isArray(arr) ? arr.join(', ') : ''
}

// Note: ...inputProps is spread before onChange/onBlur, so any caller-provided
// onChange or onBlur in inputProps will be overridden. This is intentional --
// onChange is already a named prop (array value), and no consumer needs onBlur.
// If a future caller needs to hook into these, destructure them from inputProps
// and chain them in the corresponding handlers.
function CommaSeparatedField ({ value, onChange, parseAsInt, placeholder, ...inputProps }) {
  const [text, setText] = useState(() => serialize(value))

  useEffect(() => {
    setText(serialize(value))
  }, [value])

  const handleBlur = useCallback(() => {
    const raw = text
    if (!raw.trim()) { onChange(null); setText(''); return }
    if (parseAsInt) {
      const ids = raw.split(',').map(s => parseInt(s.trim(), 10)).filter(n => !isNaN(n))
      const next = ids.length ? ids : null
      onChange(next)
      setText(next ? serialize(next) : '')
    } else {
      const arr = raw.split(',').map(s => s.trim()).filter(Boolean)
      const next = arr.length ? arr : null
      onChange(next)
      setText(next ? serialize(next) : '')
    }
  }, [text, onChange, parseAsInt])

  return (
    <SydInput
      {...inputProps}
      value={text}
      onChange={(e) => setText(e.target.value)}
      onBlur={handleBlur}
      placeholder={placeholder}
    />
  )
}

CommaSeparatedField.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  parseAsInt: PropTypes.bool,
  placeholder: PropTypes.string
}

export default CommaSeparatedField
